import { Accordion } from "@smartfaster-ui/components";
import { useTranslation } from "react-i18next";
import { useInteriorDesigner } from "../context/InteriorDesignerContext";
import { isCtaEnabled } from "../context/selectors";
import type { GenerationAction } from "../context/types";
import { useVocab } from "../hooks/useVocab";
import { ChipSelector } from "../selections/ChipSelector";
import { ExtraWishesInput } from "../selections/ExtraWishesInput";
import { ImageCardGrid } from "../selections/ImageCardGrid";
import { Panel } from "./Panel";

export function InteriorFinishingPanel() {
  const { t } = useTranslation();
  const { state, dispatch } = useInteriorDesigner();
  const { vocab } = useVocab();
  const selections = state.panelSelections.interiorFinishing;
  const ctaEnabled = isCtaEnabled({
    state,
    panelId: "interiorFinishing",
  });

  const handleCtaClick = () => {
    const actions: GenerationAction[] = [
      {
        type: "interior_finishing",
        floor: selections.floor ?? undefined,
        wall: selections.wall ?? undefined,
        extra_wensen: selections.extra_wensen || undefined,
      },
    ];
    dispatch({ type: "GENERATION_REQUESTED", actions });
  };

  return (
    <Panel
      ctaLabel={t("interiorDesigner.interiorFinishing.cta")}
      ctaHintText={t("interiorDesigner.interiorFinishing.ctaHint")}
      ctaEnabled={ctaEnabled}
      onCtaClick={handleCtaClick}
    >
      {vocab && (
        <Accordion
          multiple
          defaultValue={["floor", "wall", "wishes"]}
          variant="filled"
          color="surfaceSecondary"
        >
          <Accordion.Item
            value="floor"
            title={t("interiorDesigner.interiorFinishing.floor")}
          >
            <ImageCardGrid
              options={vocab.floors}
              value={selections.floor}
              onValueChange={({ value }) =>
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "interiorFinishing",
                  field: "floor",
                  value,
                })
              }
            />
          </Accordion.Item>

          <Accordion.Item
            value="wall"
            title={t("interiorDesigner.interiorFinishing.wall")}
          >
            <ChipSelector
              options={vocab.walls}
              value={selections.wall}
              onValueChange={({ value }) =>
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "interiorFinishing",
                  field: "wall",
                  value,
                })
              }
            />
          </Accordion.Item>

          <Accordion.Item
            value="wishes"
            title={t("interiorDesigner.interiorFinishing.extraWishes")}
          >
            <ExtraWishesInput
              value={selections.extra_wensen}
              onValueChange={({ value }) =>
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "interiorFinishing",
                  field: "extra_wensen",
                  value,
                })
              }
            />
          </Accordion.Item>
        </Accordion>
      )}
    </Panel>
  );
}
